import type { Option } from "@tento-lona/sheets";

/** Current occupant structure, independent of row versions and placement. */
export interface CellStructureFacts {
  readonly hidden: boolean;
  readonly hasMountedContent: boolean;
  readonly contentType: Option<string>;
  readonly stacked: boolean;
}

export interface ExpectedCellStructure {
  readonly hasLayout: boolean;
  readonly skipContent: boolean;
  /** Null means the caller has no resolved plugin binding. */
  readonly contentType: Option<string>;
  readonly stacked: boolean;
}

/** A version comparison is meaningful only for an already complete occupant. */
export function cellStructureMatches(
  actual: CellStructureFacts,
  expected: ExpectedCellStructure,
): boolean {
  if (actual.hidden !== !expected.hasLayout) return false;
  if (!expected.hasLayout || expected.skipContent) return true;
  return expected.contentType != null && actual.hasMountedContent &&
    actual.contentType === expected.contentType &&
    actual.stacked === expected.stacked;
}
